export default "__VITE_ASSET__CbigKokW__"